import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';

import { GenderEnum } from '~/auth/enum/gender.enum';
import { User } from '~/auth/model/user';
import { AuthService } from '~/auth/services/auth/auth.service';
import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { MenuItemInterface } from '~/component/header/login/menu/interfaces/menu-item.interface';
import { slideInOut } from '~/core/helpers/animation/animation.helper';
import { ParamethorService } from '~/paramethor/paramethor.service';
import { HeaderVariantEnum } from '../../enums/variant.enum';
import { CtaButtonTypeEnum } from '~/component/call-to-action/enums/button-type.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';
import { APP_STORAGE } from '~/app.token';

@Component({
  selector: 'app-header-login-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  animations: [slideInOut({ distance: '1rem' })],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderLoginMenuComponent {
  @Input() public isOpen = false;
  @Input() public lists: MenuItemInterface[][] = [];
  @Input() public user: User;
  @Input() public variant: HeaderVariantEnum.Organizer;

  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly iconType = VtmnPlayIconTypeEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;

  constructor(
    @Inject(APP_STORAGE) private readonly storage: Storage,
    protected readonly paramethorService: ParamethorService,
    private readonly authService: AuthService
  ) {}

  public get userImageUrl(): string {
    let filename = 'nogender.svg';

    if (this.user.gender === GenderEnum.MALE) {
      filename = 'male.svg';
    }

    if (this.user.gender === GenderEnum.FEMALE) {
      filename = 'female.svg';
    }

    return `assets/menu/${filename}`;
  }

  public logout(): void {
    this.storage.removeItem('currentOrganization');
    this.storage.removeItem('userOrganizations');
    this.authService.logout();
  }
}
